import { useTranslation } from "react-i18next";
import React, { useState, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button } from 'reactstrap';
import { setProfileProperty } from 'store/slices/personalSlice';
import { sendVerificationEmail } from 'store/slices/authSlice';
import PropertyForm from 'Components/Personal/Property/PropertyForm';
import { contactMetadata } from 'Modules/ContactModule';
import SendAgain from './SendAgain';

const EmailConfirmation = ({
  h1,
  email,
  setProfileProperty,
  sendVerificationEmail
}) => {
  const {
    t
  } = useTranslation();
  const [showForm, setShowForm] = useState(false);
  const closeForm = useCallback(() => setShowForm(false), []);
  const onSubmit = useCallback((name, localValue) => setProfileProperty(name, localValue, email.objectId).then(input => {
    // eslint-disable-next-line no-mixed-operators
    const emailVal = localValue && localValue[1] && localValue[1].value || localValue && localValue['1'] && localValue['1'].value;

    if (emailVal) {
      sendVerificationEmail(emailVal);
    }

    setShowForm(false);
    return input;
  }), [setProfileProperty, email, sendVerificationEmail]);
  const propertyMeta = useMemo(() => email && { ...contactMetadata[email.name],
    name: email.name
  }, [email]);

  if (!email) {
    return <Row>
        <Col>
          <h1>{h1}</h1>
          <p>{t("Email verification setup in progress...")}</p>
        </Col>
      </Row>;
  } // Safety check for parameters


  // eslint-disable-next-line no-mixed-operators
  if (!email.parameters || !email.parameters[1] && !email.parameters["1"]) {
    return <Row>
        <Col>
          <h1>{h1}</h1>
          <p>{t("Email verification setup in progress...")}</p>
        </Col>
      </Row>;
  } // Get email value from either numeric or string key


  const emailValue = email.parameters[1]?.value || email.parameters["1"]?.value || 'your email';
  return <>
      <Row>
        <Col>
          <h1>{h1}</h1>
          <p>{t("We've sent verificaiton email to")}{' '}
            <span className='text-monospace px-1' style={{
            backgroundColor: 'rgba(86, 61, 124, 0.15)',
            border: '1px solid rgba(86,61,124,.15)'
          }}>{emailValue}</span>
          </p>
          <p>{t("Please check your inbox and click the link in the email")}</p>
          <p>{t("(Be sure to check your spam or junk folders)")}</p>
          <p>{t("Haven't received an email?")}<SendAgain /></p>
          {!showForm && <p>{t("Need to change your email?")}<Button color='link p-0' onClick={() => setShowForm(true)}>{t("Click here")}</Button></p>}
        </Col>
      </Row>
      {showForm && <Row>
          <Col md='6'>
            <PropertyForm initValue={email.parameters || {}} property={propertyMeta} onSubmit={onSubmit} closeForm={closeForm} />
          </Col>
        </Row>}
    </>;
};

const mapDispatchToProps = dispatch => ({
  setProfileProperty: (name, value, id) => dispatch(setProfileProperty(name, value, id)),
  sendVerificationEmail: email => dispatch(sendVerificationEmail(email))
});

export default connect(null, mapDispatchToProps)(EmailConfirmation);